import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import InfiniteScroll from "react-infinite-scroll-component";
import FoodSelectionCardDisplay from "../../CardView/FoodSelectionCard/FoodSelectionCardDisplay";
import "./FoodSelection.css";

import NextButton from "./../../../Assets/Icons/Nextx.png";
import PrevButton from "./../../../Assets/Icons/left.png";
import loadingGif from "./../../../Assets/Image/loading.gif";
import "swiper/css/navigation";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

// import required modules
import { Pagination, Navigation, FreeMode } from "swiper";
import Rating from "react-rating";

import axios from "axios";
import AllFoodCard from "./AllFoodCard";
import FoodCard from "./FoodCard";
import { FoodItemList, SearchLoader } from "./../../../actions";

const FoodSelection = () => {
  // const { ref: myRef, inView: myElementIsVisible } = useInView();
  const dispatch = useDispatch();
  const foodData = useSelector((state) => state.fooditems);
  const loaderState = useSelector((state) => state.searchLoader);
  const [TotalCount, setTotalCount] = useState(0);
  const [PageNumber, setPageNumber] = useState(1);
  const [FoodItems, setFoodItems] = useState({
    foodItemList: [],
    totalCount: 0,
  });
  const myRef = useRef();
  const [intersecting, setIntersecting] = useState(false);
  const [starterSelection, setstarterSelection] = useState();
  const [mainCourseSelection, setmainCourseSelection] = useState(false);
  const [DessertSelection, setDessertSelection] = useState(false);
  const [lastScrollValue, setLastScrollValue] = useState(0);
  const filterBottomRef = useRef(null);
  const [scrollValue, setscrollValue] = useState(0);
  const [slideUp, setSlideUp] = useState(false);
  const [dataFilterCollectionss, setDataFilterCollections] = useState([]);
  const [dataSelectedKeyword, setdataSelectedKeyword] = useState(null);
  const apiAddress = process.env.REACT_APP_SECRET;
  const [showArrows, setShowArrows] = useState(true);
  const [loader, setLoader] = useState(false);
  const [hasMore, setHasMore] = useState(true);

  // useEffect(() => {
  //   // window.addEventListener("scroll", (event) => {
  //   //   if (filterBottomRef.current !== undefined) {
  //   //     const filterBarRect = filterBottomRef?.current?.getBoundingClientRect();
  //   //     const isAboveViewport =
  //   //       filterBarRect?.top < 0
  //   //         ? true
  //   //         : filterBarRect?.top == 0
  //   //         ? false
  //   //         : false;
  //   //     setIntersecting(isAboveViewport);
  //   //     var top = filterBarRect.top * -1;
  //   //     var scrollval = scrollValue * -1;
  //   //     if (top > scrollval) {
  //   //       setSlideUp(true);
  //   //     } else {
  //   //       setSlideUp(false);
  //   //     }
  //   //     var s = filterBarRect.top;
  //   //     setscrollValue(s);
  //   //   }
  //   // });
  // });

  const handleItemClick = (id) => {
    setFoodItems(() => ({
      foodItemList: [],
      totalCount: 0,
    }));

    setPageNumber(1);

    // GetFoodByKeywordTagPaged(id, 1, 10);

    setdataSelectedKeyword(id);
    if (dataSelectedKeyword !== id) {
      setdataSelectedKeyword(id);
    } else {
      setDataFilterCollections([]);
      setdataSelectedKeyword(null);
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setShowArrows(window.innerWidth > 767);
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  //test2 end
  const GetFoodByKeywordTagPaged = async (
    id,
    page,
    pageSize,
    initial = false,
  ) => {
    setLoader(true);
    await axios
      .get(
        apiAddress +
        `/api/FoodItems/GetAllFoodItemListForClientEndByKeywordTagId?keywordId=${id}&pageNo=${page}&pageSize=${pageSize}`,
      )
      .then((response) => {
        console.log(response.data);
        setFoodItems((prev) => ({
          foodItemList: [...prev.foodItemList, ...response.data.fooditemsList],
          totalCount: response.data.totalCount,
        }));
        setTotalCount(response.data.totalCount);
        setHasMore(response.data.fooditemsList.length === pageSize);  
        setLoader(false);
      })
      .catch((error) => {
        console.log(error);
      });

    if (!initial) {
      setPageNumber((prev) => prev + 1);
    }
    setLoader(false);
  };

  var res = {
    foodItemList: [],
    totalCount: 0,
  };

  const [tempFoodItems, setTempFoodItems] = useState([]);

  const GetAllFoodPaged = async (pageNo, pageSize, initial = false) => {
    if (loader) return; // prevent double triggers
    setLoader(true);

    try {
      const res = { totalCount: 0, foodItemList: [] };

      console.log("Fetching page:", pageNo, "size:", pageSize);

      // Reset only when starting fresh
      if (pageNo === 1) {
        console.log("Resetting food items for page 1");
        setPageNumber(1);
        setFoodItems({ foodItemList: [], totalCount: 0 });
      }

      if (FoodItems?.foodItemList?.length >= TotalCount && pageNo !== 1) {
        console.log("All data loaded, skipping fetch");
        setLoader(false);
        setHasMore(false);
        return;
      }

      // Fetch data
      const response = await axios.get(
        `${apiAddress}/api/FoodItems/GetFoodItemForClientendPaged?pageNo=${PageNumber}&pageSize=${pageSize}`,
      );

      const newItems = response.data.fooditemsList || [];
      const totalCount = response.data.totalCount || 0;

      res.totalCount = totalCount;
      res.foodItemList = newItems;

      setTempFoodItems((prev) => {
        const existingIds = new Set(prev.map((item) => item.id)); // track existing IDs
        const filteredNewItems = newItems.filter(
          (item) => !existingIds.has(item.id),
        ); // only add new
        return [...prev, ...filteredNewItems];
      });
      // Update state based on page
      setFoodItems((prev) => {
        let updated;

        if (pageNo === 1) {
          // Page 1 — reset with new items
          updated = {
            foodItemList: newItems,
            totalCount,
          };
        } else {
          // For next pages — append only new, unique items
          const existingIds = new Set(prev.foodItemList.map((item) => item.id)); // track existing IDs
          const filteredNewItems = newItems.filter(
            (item) => !existingIds.has(item.id),
          ); // add only items not already in list

          updated = {
            foodItemList: [...prev.foodItemList, ...filteredNewItems],
            totalCount,
          };
        }

        dispatch(FoodItemList(updated));
        return updated;
      });

      setTotalCount(totalCount);

      // Only increment page after data successfully loaded
      setPageNumber(pageNo + 1);

      return res;
    } catch (error) {
      console.error("Error fetching food items:", error);
    } finally {
      setLoader(false);
    }
  };

  console.log("Rendered with FoodItems:", tempFoodItems);
  const [dataCollections, setDataCollections] = useState([]);

  useEffect(() => {
    var res = GetAllFoodPaged(1, 7, true);
    res.then((res) => {
      dispatch(FoodItemList(res));
    });
    axios
      .get(process.env.REACT_APP_SECRET + "/api/Keyword/GetALlKeywordTag")
      .then((response) => {
        setDataCollections(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  // useEffect(() => {
  //   if (dataSelectedKeyword !== null) {
  //     GetFoodByKeywordTagPaged(dataSelectedKeyword, 1, 7, true);
  //   } else {
  //     // GetAllFoodPaged(1, 4, true);
  //     GetAllFoodPaged(1, 7);
  //   }
  // }, [dataSelectedKeyword]);

  useEffect(() => {
  setPageNumber(1);
  setFoodItems({
    foodItemList: [],
    totalCount: 0,
  });
  setHasMore(true);
  setLoader(true); 

  if (dataSelectedKeyword !== null) {
    GetFoodByKeywordTagPaged(dataSelectedKeyword, 1, 7, true);
  } else {
    GetAllFoodPaged(1, 7, true);
  }
}, [dataSelectedKeyword]);

  // Automatic screen size calculation
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1000);

  const handleResize = () => {
    setIsMobile(window.innerWidth < 1000);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  //#region Functionalities for filter bar top/fixed at scroll
  const [scrollingUp, setScrollingUp] = useState(false);
  const [scrollingDown, setScrollingDown] = useState(false);

  useEffect(() => {
    let lastScrollTop = 0;

    const filterBarDPosition = () => {
      setScrollingUp(false);
      setScrollingDown(false);

      var content = document.getElementById("FilterBarParentFixed");
      var indicator = document.getElementById("beforeFood");
      var FoodItemWidth = document.getElementById("FoodItemMainContainerId");

      if (content && indicator) {
        const filterBarRect = content.getBoundingClientRect();
        const filterBarRectIndi = indicator.getBoundingClientRect();
        const currentScrollTop =
          window.pageYOffset || document.documentElement.scrollTop;

        if (currentScrollTop > lastScrollTop) {
          if (filterBarRect.top <= -0) {
            // Scrolling down
            setScrollingDown(true);
            setScrollingUp(false);

            if (isMobile) {
              setScrollingDown(false);
              setScrollingUp(false);
            }
          }
        } else if (currentScrollTop < lastScrollTop) {
          // Scrolling up
          setScrollingDown(false);
          setScrollingUp(true);

          if (filterBarRectIndi.top >= 0) {
            setScrollingDown(false);
            setScrollingUp(false);
          }
        }

        lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
      }
    };

    window.addEventListener("scroll", filterBarDPosition);
    return () => {
      window.removeEventListener("scroll", filterBarDPosition);
    };
  }, []);

  //#endregion

  //#region:: Swiper Navigation Button functionality

  const prevRef = useRef(null);
  const nextRef = useRef(null);

  const [showPrev, setShowPrev] = useState(false);
  const [showNext, setShowNext] = useState(false);

  const handleSlideChange = (swiper) => {
    if (swiper.isEnd) {
      setShowNext(false);
    } else {
      setShowNext(true);
    }

    if (swiper.isBeginning) {
      setShowPrev(false);
    } else {
      setShowPrev(true);
    }
  };

  useEffect(() => {
    const content = document.querySelector(".swiper-horizontal");
    if (content) {
      const isScrollable = content.scrollWidth > content.clientWidth;
      if (isScrollable) {
        setShowNext(true);
      }
    }
  }, [dataCollections]);

  //#endregion

  return (
    <div id="foodSelectionMainDiv">
      <div>
        {/* Filter Bar */}
        <div
          className={`${scrollingDown ? "FilterBarParentFixedDown" : ""} ${scrollingUp ? "FilterBarParentFixedUp" : ""
            } FilterBarWrapper FoodSelection customContainerFilterBarHome `}
          id="FilterBarParentFixed"
        >
          <div
            className={` g-4 mx-auto justify-content-center selectionButton scrollbtnMobile  ${intersecting ? "HideSelectionSingleButton" : ""
              }`}
            ref={myRef}
            id="FilterBarChild"
          >
            <hr style={{ margin: "0px" }} />
            <Swiper
              className="menusliderDiv menuslider row-cols-1  row-cols-md-4 ml-0"
              style={{ position: "relative" }}
              spaceBetween={30}
              grabCursor={false}
              indicator={false}
              centeredSlides={false}
              slidesPerView={"auto"}
              hashNavigation={{
                watchState: false,
              }}
              breakpoints={{
                300: {
                  slidesPerView: 3,
                  spaceBetween: 8,
                },
                350: {
                  slidesPerView: 3.5,
                  spaceBetween: 8,
                },
                450: {
                  slidesPerView: 4,
                  spaceBetween: 8,
                },
                640: {
                  slidesPerView: 6,
                  spaceBetween: 8,
                },
                768: {
                  slidesPerView: 6.5,
                  spaceBetween: 16,
                },
                1024: {
                  slidesPerView: 3,
                  spaceBetween: 16,
                },
                1200: {
                  slidesPerView: 3,
                  spaceBetween: 16,
                },
                1400: {
                  slidesPerView: 3,
                  spaceBetween: 16,
                },
              }}
              navigation={{
                prevEl: prevRef.current,
                nextEl: nextRef.current,
              }}
              modules={[Navigation, FreeMode]}
              freeMode={true}
              onSlideChange={handleSlideChange}
            >
              {dataCollections?.map((d, index) => (
                <SwiperSlide key={index} className="slider-content-home">
                  <div
                    className={`mobileStyle cardShadow-Home d-flex align-items-center justify-content-between p-3 py-3 my-2 selectionSingleButton ${dataSelectedKeyword === d.id ? " pillCardSelect" : ""
                      }`}
                    onClick={() => handleItemClick(d.id)}
                    style={{ cursor: "pointer" }}
                  >
                    <h2 className="homePageKeywordName">{d.keywordTagName}</h2>
                    <img
                      className="homepagefilterbar-image img-fluid img-fluid-mobile"
                      src={d.keywordTagImage}
                      alt="..."
                    />
                  </div>
                </SwiperSlide>
              ))}

              {/* Custom Navigation Buttons */}
              <div
                className="buttonParentPrev"
                ref={prevRef}
                style={{ display: showPrev ? "" : "none" }}
              >
                <img src={PrevButton} style={{ width: "65%", height: "55%" }} />
              </div>

              <div
                className="buttonParentNext"
                ref={nextRef}
                style={{ display: showNext ? "" : "none" }}
              >
                <img src={NextButton} style={{ width: "65%", height: "55%" }} />
              </div>
            </Swiper>
            <hr style={{ margin: "0px" }} />
          </div>
        </div>

        <div
          ref={filterBottomRef}
          id="beforeFood"
          style={{ marginTop: "0px", transition: "all 0.1s ease" }}
        ></div>

        {/* sticky design  */}
        <div
          className={`pillSticky ${intersecting
              ? slideUp
                ? "slide-down "
                : "slideDownMore"
              : "slide-up"
            }`}
        >
          <div className="pillDisplay">
            <div className="d-flex pillItem">
              <Swiper
                className=" row row-cols-1  row-cols-md-4"
                spaceBetween={30}
                grabCursor={false}
                centeredSlides={false}
                slidesPerView={"auto"}
                hashNavigation={{
                  watchState: true,
                }}
                breakpoints={{
                  300: {
                    slidesPerView: 3,
                    spaceBetween: 5,
                  },
                  640: {
                    slidesPerView: 3,
                    spaceBetween: 5,
                  },
                  768: {
                    slidesPerView: 3,
                    spaceBetween: 10,
                  },
                  1024: {
                    slidesPerView: 3,
                    spaceBetween: 10,
                  },
                  1200: {
                    slidesPerView: 3,
                    spaceBetween: 10,
                  },
                  1400: {
                    slidesPerView: 3,
                    spaceBetween: 10,
                  },
                }}
              >
                {dataCollections?.map((d, index) => (
                  <SwiperSlide key={index}>
                    <div
                      className={`pillCard pillBtnOne d-flex align-items-center   ${starterSelection === d.id ? "pillCardSelect" : ""
                        }`}
                      onClick={() => {
                        handleItemClick(d.id);
                        setstarterSelection(d.id);
                      }}
                    >
                      <img
                        className="img-fluid"
                        src={d.keywordTagImage}
                        alt="..."
                      />
                      <h2>{d.keywordTagName}</h2>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>

        {/* <AllFoodCard
          restaurantName={"Pot kettle"}
          dataFilterCollectionss={dataFilterCollectionss}
          dataSelectedKeyword={dataSelectedKeyword}
        ></AllFoodCard>{" "} */}

        {/* FoodItems */}
        <div
          id="FoodItemMainContainerId"
          className="FoodItemMainContainer foodSelectionContainer mx-auto newFeedback"
          style={{
            minHeight: FoodItems.foodItemList.length > 0 ? "600px" : "300px",
          }}
        >
          <div
            style={{
              position: "fixed",
              bottom: "0",
              left: "0",
              color: "transparent",
            }}
          >
            Loaded food Items length:{" "}
            {JSON.stringify(FoodItems.foodItemList.length)}
            <hr />
            TotalCount: {JSON.stringify(TotalCount)}
            <hr />
            Page No: {JSON.stringify(PageNumber)}
            <hr />
            hasMore: {JSON.stringify(hasMore)}
            <hr />
            Temp: {JSON.stringify(tempFoodItems?.length)}
          </div>

          {FoodItems.foodItemList.length > 0 ? (
            <InfiniteScroll
              dataLength={FoodItems.foodItemList.length}
              // next={() => GetAllFoodPaged(PageNumber, 7)}
              next={() => {
                if (dataSelectedKeyword) {
                  GetFoodByKeywordTagPaged(dataSelectedKeyword, PageNumber, 7);
                } else {
                  GetAllFoodPaged(PageNumber, 7);
                }
              }}
              hasMore={hasMore}
              loader={
                <div className="d-flex justify-content-center">
                  <img src={loadingGif} alt="Loading..." />
                </div>
              }
              scrollThreshold={0.9}
            >
              <div className="testContainer" style={{ minHeight: "750px", overflow: "hidden" }}>
                {FoodItems.foodItemList.map((dt, i) => (
                  <FoodCard key={dt.id || i} foodItemData={dt} />
                ))}
              </div>
            </InfiniteScroll>
          ) : (
            <>
              {!loader ? (
                <>
                  <p
                    className="text-center text-muted p-4"
                    style={{ marginTop: "100px" }}
                  >
                    No food items found
                  </p>
                </>
              ) : (
                <div className="d-flex justify-content-center ">
                  <img src={loadingGif} alt="" srcset="" />
                </div>
              )}
            </>
          )}
        </div>

        {/* <div className="d-none">
          <div className="d-flex flex-wrap justify-content-center">
            <div className="foodcart test m-3">
              <div className="d-flex justify-content-end cartIcon">
                <i className="fa fa-plus-circle "></i>
              </div>

              <Swiper
                pagination={{
                  dynamicBullets: true,
                }}
                navigation={true}
                modules={[Pagination, Navigation]}
                className="foodcartimg"
              >
                <SwiperSlide>
                  <img
                    src={img3}
                    className="card-img-top img-fluid"
                    alt="..."
                  />
                </SwiperSlide>
                <SwiperSlide>
                  <img
                    src={cardImage}
                    className="card-img-top img-fluid "
                    alt="..."
                  />
                </SwiperSlide>
                <SwiperSlide>
                  <img
                    src={img1}
                    className="card-img-top img-fluid"
                    alt="..."
                  />
                </SwiperSlide>
                <SwiperSlide>
                  <img
                    src={img2}
                    className="card-img-top img-fluid"
                    alt="..."
                  />
                </SwiperSlide>
              </Swiper>

              <div className="foodCartText mt-2">
                <div className="d-flex justify-content-between commentLove">
                  <div className="d-flex commentLove">
                    <i className="fa-regular fa-heart "></i>
                    <i className="fa-sharp fa-regular fa-comment-dots"></i>
                  </div>
                 
                  <div className="rating-Font mb-1 d-flex align-items-center starRating">
                    {" "}
                    <Rating
                      className="ratingStar"
                      initialRating={Number(4.5)}
                      emptySymbol="far fa-star icon-color"
                      fullSymbol="fas fa-star icon-color"
                      readonly
                    ></Rating>
                    4.5
                  </div>
                </div>
                <div className="d-flex justify-content-between ">
                  <h3 className="m-0 p-0">Bread Toast</h3>
                  <h4 className="m-0 p-0">10.5$</h4>
                </div>
                <p className="my-1">Topped with tomato, bocconcini... </p>
                <div className="d-flex justify-content-between align-items-center">
                  <div className="d-flex align-items-center">
                    <h6>Red Flame Resta...</h6>
                    <div className="d-flex align-items-center starRating">
                      <i className="fa-sharp fa-solid fa-star"></i>
                      <h4 className="m-0 p-0">4.5</h4>
                    </div>
                  </div>

                  <button className="follow-BUtton btn ms-1">Follow</button>
                </div>

                <div className="d-flex align-items-center">
                  <img src={LeoImg} className="me-1 userImg" alt="" />
                  <p>
                    Leo Love the art of travel. So many plac So many foods...{" "}
                  </p>
                </div>
              </div>
            </div>

            <div className="foodcart test m-3">
              <div className="d-flex justify-content-end cartIcon">
                <i className="fa fa-plus-circle "></i>
              </div>

              <Swiper
                pagination={{
                  dynamicBullets: true,
                }}
                navigation={true}
                modules={[Pagination, Navigation]}
                className="foodcartimg"
              >
                <SwiperSlide>
                  <img
                    src={cakeImg}
                    className="card-img-top img-fluid "
                    alt="..."
                  />
                </SwiperSlide>
                <SwiperSlide>
                  <img
                    src={img1}
                    className="card-img-top img-fluid"
                    alt="..."
                  />
                </SwiperSlide>
                <SwiperSlide>
                  <img
                    src={img2}
                    className="card-img-top img-fluid"
                    alt="..."
                  />
                </SwiperSlide>
                <SwiperSlide>
                  <img
                    src={img3}
                    className="card-img-top img-fluid"
                    alt="..."
                  />
                </SwiperSlide>
              </Swiper>

              <div className="foodCartText mt-2">
                <div className="d-flex justify-content-between commentLove">
                  <div className="d-flex commentLove">
                    <i className="fa-regular fa-heart "></i>
                    <i className="fa-sharp fa-regular fa-comment-dots"></i>
                  </div>
             
                  <div className="rating-Font mb-1 d-flex align-items-center starRating">
                    {" "}
                    <Rating
                      className="ratingStar"
                      initialRating={Number(4.5)}
                      emptySymbol="far fa-star icon-color"
                      fullSymbol="fas fa-star icon-color"
                      readonly
                    ></Rating>
                    4.5
                  </div>
                </div>
                <div className="d-flex justify-content-between ">
                  <h3 className="m-0 p-0">Bread Toast</h3>
                  <h4 className="m-0 p-0">10.5$</h4>
                </div>
                <p className="my-1">Topped with tomato, bocconcini... </p>
                <div className="d-flex justify-content-between align-items-center">
                  <div className="d-flex align-items-center">
                    <h6>Red Flame Resta...</h6>
                    <div className="d-flex align-items-center starRating">
                      <i className="fa-sharp fa-solid fa-star"></i>
                      <h4 className="m-0 p-0">4.5</h4>
                    </div>
                  </div>

                  <button className="follow-BUtton btn ms-1">Follow</button>
                </div>

                <div className="d-flex align-items-center">
                  <img src={LeoImg} className="me-1 userImg" alt="" />
                  <p>
                    Leo Love the art of travel. So many plac So many foods...{" "}
                  </p>
                </div>
              </div>
            </div>

            <div className="foodcart test m-3">
              <div className="d-flex justify-content-end cartIcon">
                <i className="fa fa-plus-circle "></i>
              </div>

              <Swiper
                pagination={{
                  dynamicBullets: true,
                }}
                navigation={true}
                modules={[Pagination, Navigation]}
                className="foodcartimg"
              >
                <SwiperSlide>
                  <img
                    src={soupImg}
                    className="card-img-top img-fluid "
                    alt="..."
                  />
                </SwiperSlide>
                <SwiperSlide>
                  <img
                    src={img1}
                    className="card-img-top img-fluid"
                    alt="..."
                  />
                </SwiperSlide>
                <SwiperSlide>
                  <img
                    src={img2}
                    className="card-img-top img-fluid"
                    alt="..."
                  />
                </SwiperSlide>
                <SwiperSlide>
                  <img
                    src={img3}
                    className="card-img-top img-fluid"
                    alt="..."
                  />
                </SwiperSlide>
              </Swiper>

              <div className="foodCartText mt-2">
                <div className="d-flex justify-content-between commentLove">
                  <div className="d-flex commentLove">
                    <i className="fa-regular fa-heart "></i>
                    <i className="fa-sharp fa-regular fa-comment-dots"></i>
                  </div>
            
                  <div className="rating-Font mb-1 d-flex align-items-center starRating">
                    {" "}
                    <Rating
                      className="ratingStar"
                      initialRating={Number(4.5)}
                      emptySymbol="far fa-star icon-color"
                      fullSymbol="fas fa-star icon-color"
                      readonly
                    ></Rating>
                    4.5
                  </div>
                </div>
                <div className="d-flex justify-content-between ">
                  <h3 className="m-0 p-0">Bread Toast</h3>
                  <h4 className="m-0 p-0">10.5$</h4>
                </div>
                <p className="my-1">Topped with tomato, bocconcini... </p>
                <div className="d-flex justify-content-between align-items-center">
                  <div className="d-flex align-items-center">
                    <h6>Red Flame Resta...</h6>
                    <div className="d-flex align-items-center starRating">
                      <i className="fa-sharp fa-solid fa-star"></i>
                      <h4 className="m-0 p-0">4.5</h4>
                    </div>
                  </div>

                  <button className="follow-BUtton btn ms-1">Follow</button>
                </div>

                <div className="d-flex align-items-center">
                  <img src={LeoImg} className="me-1 userImg" alt="" />
                  <p>
                    Leo Love the art of travel. So many plac So many foods...{" "}
                  </p>
                </div>
              </div>
            </div>

            <div className="foodcart test m-3">
              <div className="d-flex justify-content-end cartIcon">
                <i className="fa fa-plus-circle "></i>
              </div>

              <Swiper
                pagination={{
                  dynamicBullets: true,
                }}
                navigation={true}
                modules={[Pagination, Navigation]}
                className="foodcartimg"
              >
                <SwiperSlide>
                  <img
                    src={bannerImg}
                    className="card-img-top img-fluid "
                    alt="..."
                  />
                </SwiperSlide>
                <SwiperSlide>
                  <img
                    src={img1}
                    className="card-img-top img-fluid"
                    alt="..."
                  />
                </SwiperSlide>
                <SwiperSlide>
                  <img
                    src={img2}
                    className="card-img-top img-fluid"
                    alt="..."
                  />
                </SwiperSlide>
                <SwiperSlide>
                  <img
                    src={img3}
                    className="card-img-top img-fluid"
                    alt="..."
                  />
                </SwiperSlide>
              </Swiper>
              <div className="foodCartText mt-2">
                <div className="d-flex justify-content-between commentLove">
                  <div className="d-flex commentLove">
                    <i className="fa-regular fa-heart "></i>
                    <i className="fa-sharp fa-regular fa-comment-dots"></i>
                  </div>
              
                  <div className="rating-Font mb-1 d-flex align-items-center starRating">
                    {" "}
                    <Rating
                      className="ratingStar"
                      initialRating={Number(4.5)}
                      emptySymbol="far fa-star icon-color"
                      fullSymbol="fas fa-star icon-color"
                      readonly
                    ></Rating>
                    4.5
                  </div>
                </div>
                <div className="d-flex justify-content-between ">
                  <h3 className="m-0 p-0">Bread Toast</h3>
                  <h4 className="m-0 p-0">10.5$</h4>
                </div>
                <p className="my-1">Topped with tomato, bocconcini... </p>
                <div className="d-flex justify-content-between align-items-center">
                  <div className="d-flex align-items-center">
                    <h6>Red Flame Resta...</h6>
                    <div className="d-flex align-items-center starRating">
                      <i className="fa-sharp fa-solid fa-star"></i>
                      <h4 className="m-0 p-0">4.5</h4>
                    </div>
                  </div>

                  <button className="follow-BUtton btn ms-1">Follow</button>
                </div>

                <div className="d-flex align-items-center">
                  <img src={LeoImg} className="me-1 userImg" alt="" />
                  <p>
                    Leo Love the art of travel. So many plac So many foods...{" "}
                  </p>
                </div>
              </div>
            </div>

            <div className="foodcart test m-3">
              <div className="d-flex justify-content-end cartIcon">
                <i className="fa fa-plus-circle "></i>
              </div>

              <Swiper
                pagination={{
                  dynamicBullets: true,
                }}
                navigation={true}
                modules={[Pagination, Navigation]}
                className="foodcartimg"
              >
                <SwiperSlide>
                  <img
                    src={pastaImg}
                    className="card-img-top img-fluid "
                    alt="..."
                  />
                </SwiperSlide>
                <SwiperSlide>
                  <img
                    src={img1}
                    className="card-img-top img-fluid"
                    alt="..."
                  />
                </SwiperSlide>
                <SwiperSlide>
                  <img
                    src={img2}
                    className="card-img-top img-fluid"
                    alt="..."
                  />
                </SwiperSlide>
                <SwiperSlide>
                  <img
                    src={img3}
                    className="card-img-top img-fluid"
                    alt="..."
                  />
                </SwiperSlide>
              </Swiper>
              <div className="foodCartText mt-2">
                <div className="d-flex justify-content-between commentLove">
                  <div className="d-flex commentLove">
                    <i className="fa-regular fa-heart "></i>
                    <i className="fa-sharp fa-regular fa-comment-dots"></i>
                  </div>
             
                  <div className="rating-Font mb-1 d-flex align-items-center starRating">
                    {" "}
                    <Rating
                      className="ratingStar"
                      initialRating={Number(4.5)}
                      emptySymbol="far fa-star icon-color"
                      fullSymbol="fas fa-star icon-color"
                      readonly
                    ></Rating>
                    4.5
                  </div>
                </div>
                <div className="d-flex justify-content-between ">
                  <h3 className="m-0 p-0">Bread Toast</h3>
                  <h4 className="m-0 p-0">10.5$</h4>
                </div>
                <p className="my-1">Topped with tomato, bocconcini... </p>
                <div className="d-flex justify-content-between align-items-center">
                  <div className="d-flex align-items-center">
                    <h6>Red Flame Resta...</h6>
                    <div className="d-flex align-items-center starRating">
                      <i className="fa-sharp fa-solid fa-star"></i>
                      <h4 className="m-0 p-0">4.5</h4>
                    </div>
                  </div>

                  <button className="follow-BUtton btn ms-1">Follow</button>
                </div>

                <div className="d-flex align-items-center">
                  <img src={LeoImg} className="me-1 userImg" alt="" />
                  <p>
                    Leo Love the art of travel. So many plac So many foods...{" "}
                  </p>
                </div>
              </div>
            </div>

            <div className="foodcart test m-3">
              <div className="d-flex justify-content-end cartIcon">
                <i className="fa fa-plus-circle "></i>
              </div>

              <Swiper
                pagination={{
                  dynamicBullets: true,
                }}
                navigation={true}
                modules={[Pagination, Navigation]}
                className="foodcartimg"
              >
                <SwiperSlide>
                  <img
                    src={latteCoffeeImg}
                    className="card-img-top img-fluid "
                    alt="..."
                  />
                </SwiperSlide>
                <SwiperSlide>
                  <img
                    src={img1}
                    className="card-img-top img-fluid"
                    alt="..."
                  />
                </SwiperSlide>
                <SwiperSlide>
                  <img
                    src={img2}
                    className="card-img-top img-fluid"
                    alt="..."
                  />
                </SwiperSlide>
                <SwiperSlide>
                  <img
                    src={img3}
                    className="card-img-top img-fluid"
                    alt="..."
                  />
                </SwiperSlide>
              </Swiper>
              <div className="foodCartText mt-2">
                <div className="d-flex justify-content-between commentLove">
                  <div className="d-flex commentLove">
                    <i className="fa-regular fa-heart "></i>
                    <i className="fa-sharp fa-regular fa-comment-dots"></i>
                  </div>
          
                  <div className="rating-Font mb-1 d-flex align-items-center starRating">
                    {" "}
                    <Rating
                      className="ratingStar"
                      initialRating={Number(4.5)}
                      emptySymbol="far fa-star icon-color"
                      fullSymbol="fas fa-star icon-color"
                      readonly
                    ></Rating>
                    4.5
                  </div>
                </div>
                <div className="d-flex justify-content-between ">
                  <h3 className="m-0 p-0">Bread Toast</h3>
                  <h4 className="m-0 p-0">10.5$</h4>
                </div>
                <p className="my-1">Topped with tomato, bocconcini... </p>
                <div className="d-flex justify-content-between align-items-center">
                  <div className="d-flex align-items-center">
                    <h6>Red Flame Resta...</h6>
                    <div className="d-flex align-items-center starRating">
                      <i className="fa-sharp fa-solid fa-star"></i>
                      <h4 className="m-0 p-0">4.5</h4>
                    </div>
                  </div>

                  <button className="follow-BUtton btn ms-1">Follow</button>
                </div>

                <div className="d-flex align-items-center">
                  <img src={LeoImg} className="me-1 userImg" alt="" />
                  <p>
                    Leo Love the art of travel. So many plac So many foods...{" "}
                  </p>
                </div>
              </div>
            </div>

            <div className="foodcart test m-3">
              <div className="d-flex justify-content-end cartIcon">
                <i className="fa fa-plus-circle "></i>
              </div>

              <Swiper
                pagination={{
                  dynamicBullets: true,
                }}
                navigation={true}
                modules={[Pagination, Navigation]}
                className="foodcartimg"
              >
                <SwiperSlide>
                  <img
                    src={chickenImg}
                    className="card-img-top img-fluid "
                    alt="..."
                  />
                </SwiperSlide>
                <SwiperSlide>
                  <img
                    src={img1}
                    className="card-img-top img-fluid"
                    alt="..."
                  />
                </SwiperSlide>
                <SwiperSlide>
                  <img
                    src={img2}
                    className="card-img-top img-fluid"
                    alt="..."
                  />
                </SwiperSlide>
                <SwiperSlide>
                  <img
                    src={img3}
                    className="card-img-top img-fluid"
                    alt="..."
                  />
                </SwiperSlide>
              </Swiper>
              <div className="foodCartText mt-2">
                <div className="d-flex justify-content-between commentLove">
                  <div className="d-flex commentLove">
                    <i className="fa-regular fa-heart "></i>
                    <i className="fa-sharp fa-regular fa-comment-dots"></i>
                  </div>
               
                  <div className="rating-Font mb-1 d-flex align-items-center starRating">
                    {" "}
                    <Rating
                      className="ratingStar"
                      initialRating={Number(4.5)}
                      emptySymbol="far fa-star icon-color"
                      fullSymbol="fas fa-star icon-color"
                      readonly
                    ></Rating>
                    4.5
                  </div>
                </div>
                <div className="d-flex justify-content-between ">
                  <h3 className="m-0 p-0">Bread Toast</h3>
                  <h4 className="m-0 p-0">10.5$</h4>
                </div>
                <p className="my-1">Topped with tomato, bocconcini... </p>
                <div className="d-flex justify-content-between align-items-center">
                  <div className="d-flex align-items-center">
                    <h6>Red Flame Resta...</h6>
                    <div className="d-flex align-items-center starRating">
                      <i className="fa-sharp fa-solid fa-star"></i>
                      <h4 className="m-0 p-0">4.5</h4>
                    </div>
                  </div>

                  <button className="follow-BUtton btn ms-1">Follow</button>
                </div>

                <div className="d-flex align-items-center">
                  <img src={LeoImg} className="me-1 userImg" alt="" />
                  <p>
                    Leo Love the art of travel. So many plac So many foods...{" "}
                  </p>
                </div>
              </div>
            </div>

            <div className="foodcart test m-3">
              <div className="d-flex justify-content-end cartIcon">
                <i className="fa fa-plus-circle "></i>
              </div>

              <Swiper
                pagination={{
                  dynamicBullets: true,
                }}
                navigation={true}
                modules={[Pagination, Navigation]}
                className="foodcartimg"
              >
                <SwiperSlide>
                  <img
                    src={img2}
                    className="card-img-top img-fluid "
                    alt="..."
                  />
                </SwiperSlide>
                <SwiperSlide>
                  <img
                    src={img1}
                    className="card-img-top img-fluid"
                    alt="..."
                  />
                </SwiperSlide>
                <SwiperSlide>
                  <img
                    src={img2}
                    className="card-img-top img-fluid"
                    alt="..."
                  />
                </SwiperSlide>
                <SwiperSlide>
                  <img
                    src={img3}
                    className="card-img-top img-fluid"
                    alt="..."
                  />
                </SwiperSlide>
              </Swiper>
              <div className="foodCartText mt-2">
                <div className="d-flex justify-content-between commentLove">
                  <div className="d-flex commentLove">
                    <i className="fa-regular fa-heart "></i>
                    <i className="fa-sharp fa-regular fa-comment-dots"></i>
                  </div>
              
                  <div className="rating-Font mb-1 d-flex align-items-center starRating">
                    {" "}
                    <Rating
                      className="ratingStar"
                      initialRating={Number(4.5)}
                      emptySymbol="far fa-star icon-color"
                      fullSymbol="fas fa-star icon-color"
                      readonly
                    ></Rating>
                    4.5
                  </div>
                </div>
                <div className="d-flex justify-content-between ">
                  <h3 className="m-0 p-0">Bread Toast</h3>
                  <h4 className="m-0 p-0">10.5$</h4>
                </div>
                <p className="my-1">Topped with tomato, bocconcini... </p>
                <div className="d-flex justify-content-between align-items-center">
                  <div className="d-flex align-items-center">
                    <h6>Red Flame Resta...</h6>
                    <div className="d-flex align-items-center starRating">
                      <i className="fa-sharp fa-solid fa-star"></i>
                      <h4 className="m-0 p-0">4.5</h4>
                    </div>
                  </div>

                  <button className="follow-BUtton btn ms-1">Follow</button>
                </div>

                <div className="d-flex align-items-center">
                  <img src={LeoImg} className="me-1 userImg" alt="" />
                  <p>
                    Leo Love the art of travel. So many plac So many foods...{" "}
                  </p>
                </div>
              </div>
            </div>

            <div className="foodcart test m-3">
              <div className="d-flex justify-content-end cartIcon">
                <i className="fa fa-plus-circle "></i>
              </div>

              <Swiper
                pagination={{
                  dynamicBullets: true,
                }}
                navigation={true}
                modules={[Pagination, Navigation]}
                className="foodcartimg"
              >
                <SwiperSlide>
                  <img
                    src={latteCoffeeImg}
                    className="card-img-top img-fluid "
                    alt="..."
                  />
                </SwiperSlide>
                <SwiperSlide>
                  <img
                    src={img1}
                    className="card-img-top img-fluid"
                    alt="..."
                  />
                </SwiperSlide>
                <SwiperSlide>
                  <img
                    src={img2}
                    className="card-img-top img-fluid"
                    alt="..."
                  />
                </SwiperSlide>
                <SwiperSlide>
                  <img
                    src={img3}
                    className="card-img-top img-fluid"
                    alt="..."
                  />
                </SwiperSlide>
              </Swiper>
              <div className="foodCartText mt-2">
                <div className="d-flex justify-content-between commentLove">
                  <div className="d-flex commentLove">
                    <i className="fa-regular fa-heart "></i>
                    <i className="fa-sharp fa-regular fa-comment-dots"></i>
                  </div>
              
                  <div className="rating-Font mb-1 d-flex align-items-center starRating">
                    {" "}
                    <Rating
                      className="ratingStar"
                      initialRating={Number(4.5)}
                      emptySymbol="far fa-star icon-color"
                      fullSymbol="fas fa-star icon-color"
                      readonly
                    ></Rating>
                    4.5
                  </div>
                </div>
                <div className="d-flex justify-content-between ">
                  <h3 className="m-0 p-0">Bread Toast</h3>
                  <h4 className="m-0 p-0">10.5$</h4>
                </div>
                <p className="my-1">Topped with tomato, bocconcini... </p>
                <div className="d-flex justify-content-between align-items-center">
                  <div className="d-flex align-items-center">
                    <h6>Red Flame Resta...</h6>
                    <div className="d-flex align-items-center starRating">
                      <i className="fa-sharp fa-solid fa-star"></i>
                      <h4 className="m-0 p-0">4.5</h4>
                    </div>
                  </div>

                  <button className="follow-BUtton btn ms-1">Follow</button>
                </div>

                <div className="d-flex align-items-center">
                  <img src={LeoImg} className="me-1 userImg" alt="" />
                  <p>
                    Leo Love the art of travel. So many plac So many foods...{" "}
                  </p>
                </div>
              </div>
            </div>

            <div className="foodcart test m-3">
              <div className="d-flex justify-content-end cartIcon">
                <i className="fa fa-plus-circle "></i>
              </div>

              <Swiper
                pagination={{
                  dynamicBullets: true,
                }}
                navigation={true}
                modules={[Pagination, Navigation]}
                className="foodcartimg"
              >
                <SwiperSlide>
                  <img
                    src={kababImg}
                    className="card-img-top img-fluid "
                    alt="..."
                  />
                </SwiperSlide>
                <SwiperSlide>
                  <img
                    src={img1}
                    className="card-img-top img-fluid"
                    alt="..."
                  />
                </SwiperSlide>
                <SwiperSlide>
                  <img
                    src={img2}
                    className="card-img-top img-fluid"
                    alt="..."
                  />
                </SwiperSlide>
                <SwiperSlide>
                  <img
                    src={img3}
                    className="card-img-top img-fluid"
                    alt="..."
                  />
                </SwiperSlide>
              </Swiper>
              <div className="foodCartText mt-2">
                <div className="d-flex justify-content-between commentLove">
                  <div className="d-flex commentLove">
                    <i className="fa-regular fa-heart "></i>
                    <i className="fa-sharp fa-regular fa-comment-dots"></i>
                  </div>
           
                  <div className="rating-Font mb-1 d-flex align-items-center starRating">
                    {" "}
                    <Rating
                      className="ratingStar"
                      initialRating={Number(4.5)}
                      emptySymbol="far fa-star icon-color"
                      fullSymbol="fas fa-star icon-color"
                      readonly
                    ></Rating>
                    4.5
                  </div>
                </div>
                <div className="d-flex justify-content-between ">
                  <h3 className="m-0 p-0">Bread Toast</h3>
                  <h4 className="m-0 p-0">10.5$</h4>
                </div>
                <p className="my-1">Topped with tomato, bocconcini... </p>
                <div className="d-flex justify-content-between align-items-center">
                  <div className="d-flex align-items-center">
                    <h6>Red Flame Resta...</h6>
                    <div className="d-flex align-items-center starRating">
                      <i className="fa-sharp fa-solid fa-star"></i>
                      <h4 className="m-0 p-0">4.5</h4>
                    </div>
                  </div>

                  <button className="follow-BUtton btn ms-1">Follow</button>
                </div>

                <div className="d-flex align-items-center">
                  <img src={LeoImg} className="me-1 userImg" alt="" />
                  <p>
                    Leo Love the art of travel. So many plac So many foods...{" "}
                  </p>
                </div>
              </div>
            </div>
            <div className="foodcart test m-3">
              <div className="d-flex justify-content-end cartIcon">
                <i className="fa fa-plus-circle "></i>
                
              </div>

              <Swiper
                pagination={{
                  dynamicBullets: true,
                }}
                navigation={true}
                modules={[Pagination, Navigation]}
                className="foodcartimg"
              >
                <SwiperSlide>
                  <img
                    src={cardImage}
                    className="card-img-top img-fluid "
                    alt="..."
                  />
                </SwiperSlide>
                <SwiperSlide>
                  <img
                    src={img1}
                    className="card-img-top img-fluid"
                    alt="..."
                  />
                </SwiperSlide>
                <SwiperSlide>
                  <img
                    src={img2}
                    className="card-img-top img-fluid"
                    alt="..."
                  />
                </SwiperSlide>
                <SwiperSlide>
                  <img
                    src={img3}
                    className="card-img-top img-fluid"
                    alt="..."
                  />
                </SwiperSlide>
              </Swiper>
              <div className="foodCartText mt-2">
                <div className="d-flex justify-content-between commentLove">
                  <div className="d-flex commentLove">
                    <i className="fa-regular fa-heart "></i>
                    <i className="fa-sharp fa-regular fa-comment-dots"></i>
                  </div>
                 
                  <div className="rating-Font mb-1 d-flex align-items-center starRating">
                    {" "}
                    <Rating
                      className="ratingStar"
                      initialRating={Number(4.5)}
                      emptySymbol="far fa-star icon-color"
                      fullSymbol="fas fa-star icon-color"
                      readonly
                    ></Rating>
                    4.5
                  </div>
                </div>
                <div className="d-flex justify-content-between ">
                  <h3 className="m-0 p-0">Bread Toast</h3>
                  <h4 className="m-0 p-0">10.5$</h4>
                </div>
                <p className="my-1">Topped with tomato, bocconcini... </p>
                <div className="d-flex justify-content-between align-items-center">
                  <div className="d-flex align-items-center">
                    <h6>Red Flame Resta...</h6>
                    <div className="d-flex align-items-center starRating">
                      <i className="fa-sharp fa-solid fa-star"></i>
                      <h4 className="m-0 p-0">4.5</h4>
                    </div>
                  </div>

                  <button className="follow-BUtton btn ms-1">Follow</button>
                </div>

                <div className="d-flex align-items-center">
                  <img src={LeoImg} className="me-1 userImg" alt="" />
                  <p>
                    Leo Love the art of travel. So many plac So many foods...{" "}
                  </p>
                </div>
              </div>
            </div>

            <div className="foodcart test m-3">
              <div className="d-flex justify-content-end cartIcon">
                <i className="fa fa-plus-circle "></i>
              
              </div>

              <Swiper
                pagination={{
                  dynamicBullets: true,
                }}
                navigation={true}
                modules={[Pagination, Navigation]}
                className="foodcartimg"
              >
                <SwiperSlide>
                  <img
                    src={img1}
                    className="card-img-top img-fluid"
                    alt="..."
                  />
                </SwiperSlide>
                <SwiperSlide>
                  <img
                    src={cardImage}
                    className="card-img-top img-fluid "
                    alt="..."
                  />
                </SwiperSlide>
                <SwiperSlide>
                  <img
                    src={img2}
                    className="card-img-top img-fluid"
                    alt="..."
                  />
                </SwiperSlide>
                <SwiperSlide>
                  <img
                    src={img3}
                    className="card-img-top img-fluid"
                    alt="..."
                  />
                </SwiperSlide>
              </Swiper>
              <div className="foodCartText mt-2">
                <div className="d-flex justify-content-between commentLove">
                  <div className="d-flex commentLove">
                    <i className="fa-regular fa-heart "></i>
                    <i className="fa-sharp fa-regular fa-comment-dots"></i>
                  </div>
              
                  <div className="rating-Font mb-1 d-flex align-items-center starRating">
                    {" "}
                    <Rating
                      className="ratingStar"
                      initialRating={Number(4.5)}
                      emptySymbol="far fa-star icon-color"
                      fullSymbol="fas fa-star icon-color"
                      readonly
                    ></Rating>
                    4.5
                  </div>
                </div>
                <div className="d-flex justify-content-between ">
                  <h3 className="m-0 p-0">Bread Toast</h3>
                  <h4 className="m-0 p-0">10.5$</h4>
                </div>
                <p className="my-1">Topped with tomato, bocconcini... </p>
                <div className="d-flex justify-content-between align-items-center">
                  <div className="d-flex align-items-center">
                    <h6>Red Flame Resta...</h6>
                    <div className="d-flex align-items-center starRating">
                      <i className="fa-sharp fa-solid fa-star"></i>
                      <h4 className="m-0 p-0">4.5</h4>
                    </div>
                  </div>

                  <button className="follow-BUtton btn ms-1">Follow</button>
                </div>

                <div className="d-flex align-items-center">
                  <img src={LeoImg} className="me-1 userImg" alt="" />
                  <p>
                    Leo Love the art of travel. So many plac So many foods...{" "}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
};

function getCards() {
  let count = 10;
  let cards = [];
  for (let index = 0; index < count; index++) {
    cards.push(<FoodSelectionCardDisplay></FoodSelectionCardDisplay>);
  }
  return cards;
}
function scroll() {
  console.log("Scroll");
}

export default FoodSelection;
